import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRespone } from 'src/app/models/common.response';
import { environment } from 'src/environments/environment';
import { AbdmHiuConsent, AbdmHiuRecord, CreateAbdmHiuConsent } from './abdm-health-records.type';

@Injectable({ providedIn: 'root' })
export class AbdmHealthRecordsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.baseURl}/abha/hiu`;

  createConsent(request: CreateAbdmHiuConsent): Observable<BaseRespone<AbdmHiuConsent>> {
    return this.http.post<BaseRespone<AbdmHiuConsent>>(`${this.baseUrl}/consent-requests`, request);
  }

  retryConsent(id: number): Observable<BaseRespone<AbdmHiuConsent>> {
    return this.http.post<BaseRespone<AbdmHiuConsent>>(`${this.baseUrl}/consent-requests/${id}/retry`, {});
  }

  fetchConsent(id: number): Observable<BaseRespone<AbdmHiuConsent>> {
    return this.http.post<BaseRespone<AbdmHiuConsent>>(`${this.baseUrl}/consent-requests/${id}/fetch`, {});
  }

  checkConsentStatus(id: number): Observable<BaseRespone<AbdmHiuConsent>> {
    return this.http.post<BaseRespone<AbdmHiuConsent>>(`${this.baseUrl}/consent-requests/${id}/status`, {});
  }

  getConsents(patientId: number): Observable<BaseRespone<AbdmHiuConsent[]>> {
    return this.http.get<BaseRespone<AbdmHiuConsent[]>>(`${this.baseUrl}/patients/${patientId}/consent-requests`);
  }

  getRecords(patientId: number): Observable<BaseRespone<AbdmHiuRecord[]>> {
    return this.http.get<BaseRespone<AbdmHiuRecord[]>>(`${this.baseUrl}/patients/${patientId}/records`);
  }

  getRecord(id: number): Observable<BaseRespone<AbdmHiuRecord>> {
    return this.http.get<BaseRespone<AbdmHiuRecord>>(`${this.baseUrl}/records/${id}`);
  }
}
